import styled from "styled-components";

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
`;